/**
 * Five-stage pipeline visual:
 * Phone Video → Movement Signals → Biomechanical Interpretation → Reliability Check → Structured Feedback
 */
const STAGES = [
  { label: 'Phone video', hint: 'Ordinary smartphone capture' },
  { label: 'Movement signals', hint: 'Visible body movement extracted' },
  { label: 'Biomechanical interpretation', hint: 'Mechanically meaningful patterns' },
  { label: 'Reliability check', hint: 'Is the evidence strong enough?' },
  { label: 'Structured feedback', hint: 'Plain-language observations' },
];

export default function Pipeline() {
  return (
    <div className="relative">
      {/* Desktop: horizontal */}
      <div className="hidden lg:grid grid-cols-5 gap-4">
        {STAGES.map((s, i) => (
          <div key={s.label} className="relative">
            <div className="rounded-2xl bg-vl-surface border hairline p-5 h-full">
              <p className="mono-label text-vl-ink/45">Stage {i + 1}</p>
              <p className="font-serif-display text-[22px] text-vl-ink leading-tight mt-1.5">{s.label}</p>
              <p className="text-sm text-vl-ink/65 mt-2 leading-relaxed">{s.hint}</p>
              {i === 3 && (
                <span className="mt-3 inline-block mono-label text-[#4C7C59] bg-[#4C7C59]/10 px-2 py-1 rounded-full">
                  Differentiator
                </span>
              )}
            </div>
            {i < STAGES.length - 1 && (
              <svg
                className="absolute top-1/2 -right-3 -translate-y-1/2 hidden lg:block"
                width="24"
                height="14"
                viewBox="0 0 24 14"
                fill="none"
              >
                <line x1="0" y1="7" x2="22" y2="7" stroke="#6B6699" strokeWidth="1.5" className="vl-dash" />
                <path d="M18 3 L24 7 L18 11" stroke="#6B6699" strokeWidth="1.5" fill="none" />
              </svg>
            )}
          </div>
        ))}
      </div>

      {/* Mobile: vertical */}
      <div className="lg:hidden space-y-3">
        {STAGES.map((s, i) => (
          <div key={s.label} className="relative pl-8">
            <span className="absolute left-0 top-3 inline-flex h-6 w-6 items-center justify-center rounded-full bg-vl-ink text-vl-bg font-mono text-[11px]">
              {i + 1}
            </span>
            {i < STAGES.length - 1 && (
              <span className="absolute left-3 top-9 bottom-0 w-px bg-vl-violet/40" aria-hidden="true" />
            )}
            <div className="rounded-2xl bg-vl-surface border hairline p-4">
              <p className="font-serif-display text-lg text-vl-ink">{s.label}</p>
              <p className="text-sm text-vl-ink/65 mt-1">{s.hint}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
